import React from "react";
import { DatePicker } from '@progress/kendo-react-dateinputs';
import { convertStringToDateStr } from '../libs/DateHelper';
import {InlineCellProps} from './CustomProps';

const DatePickerCell: React.FC<InlineCellProps> = ({dataItem, field,required, className, onChange,  ...props}) =>{
    const handleChange = (e: any) => {
		const item = { ...dataItem, [field!]: e.target.value };
		onChange!({
			...props,
			dataItem: item,
			syntheticEvent: e.syntheticEvent,
			field: field,
			value: e.target.value,
		});
	}
    return (
        <td  className={className}>
            {
                dataItem.inEdit ? (
                    <DatePicker
                        required={required}
                        value={dataItem[field!]}
                        onChange={handleChange}
                        width={'100%'}
                        format='dd/MM/yyyy'
                    />
                ) : (<span> { convertStringToDateStr(dataItem, field!) } </span>) 
            }
        </td>
    )
}

export default DatePickerCell;